import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Layout from './components/layout'
import data from './lib/siteData.json'
import './App.scss'

import Home from './pages/home'
import Quote from './pages/familyHistory/quote'
import Family from './pages/familyHistory/family'
import Person from './pages/familyHistory/person'
import ChangeMakers from './pages/changeMakers'
import FamilyAtWork from './pages/familyAtWork'

export default function App () {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Layout data={data} />}>
          <Route path='/ames-family-history'>
            {data.people.map((person) => (
              <Route path={`/ames-family-history/${person.key}`} element={<Person data={person} />} key={person.key} />
            ))}
            <Route path='/ames-family-history/family' element={<Family />} />
            <Route index element={<Quote />} />
          </Route>
          <Route path='/ames-change-makers' element={<ChangeMakers data={data.changeMakers} />} />
          <Route path='/ames-family-at-work' element={<FamilyAtWork data={data.familyAtWork} />} />
          <Route index element={<Home />} />
        </Route>
      </Routes>
    </Router>
  )
}
